/// <reference types="vite/client" />
import matter from 'gray-matter';

export interface BlogPost {
    slug: string;
    title: string;
    date: string;
    description: string;
    author: string;
    content: string;
}

export function getBlogPosts(): BlogPost[] {
    const modules = import.meta.glob('/src/content/blog/*.md', { query: '?raw', import: 'default', eager: true });

    const posts = Object.entries(modules).map(([path, fileContent]) => {
        const slug = path.split('/').pop()?.replace('.md', '') || '';
        const { data, content } = matter(fileContent as string);

        return {
            slug,
            title: data.title || 'Untitled',
            date: data.date || new Date().toISOString(),
            description: data.description || '',
            author: data.author || 'Anonymous',
            content,
        };
    });

    return posts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
}

export function getBlogPost(slug: string): BlogPost | undefined {
    const posts = getBlogPosts();
    return posts.find((post) => post.slug === slug);
}
